import { bootstrapApplication } from "@angular/platform-browser";
import { appConfig } from "./app/app.config";
import { App } from "./app/app";

// Build hash bump 2026-04-27: force new main bundle filename to bypass
// stale Cloudflare cache poisoned during a prior deploy.
bootstrapApplication(App, appConfig).catch((err) => console.error(err));
